import { useMemo } from 'react';

import type { PreTradeResponseData } from '../../../redux/preTradeApi';
import type { TotalCostRiskData } from '../../../types';
import { parseTotalCostRisk } from '../../../utils';

export function useTotalCostRisk(scenario?: PreTradeResponseData): { data?: TotalCostRiskData } {
  const data = useMemo(() => parseTotalCostRisk(scenario?.Analytics ?? []), [scenario?.Analytics]);

  return { data };
}
